exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n[class*=\"col-\"][data-v-4a045ee4] {\n  padding: 0;\n}\ndiv.plat-form-icon img[data-v-4a045ee4]{\n  margin: 5px 10px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-4a045ee4","scoped":true,"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/information/BeneatForBussiness.vue
// module id = 1627
// module chunks = 0